//pending raw orders
export const ALL_PENDING_RAW_ORDERS_REQUEST = "ALL_PENDING_RAW_ORDERS_REQUEST";
export const ALL_PENDING_RAW_ORDERS_SUCCESS = "ALL_PENDING_RAW_ORDERS_SUCCESS";
export const ALL_PENDING_RAW_ORDERS_FAIL = "ALL_PENDING_RAW_ORDERS_FAIL";

//pending group orders
export const ALL_PENDING_GROUP_ORDERS_REQUEST = "ALL_PENDING_GROUP_ORDERS_REQUEST";
export const ALL_PENDING_GROUP_ORDERS_SUCCESS = "ALL_PENDING_GROUP_ORDERS_SUCCESS";
export const ALL_PENDING_GROUP_ORDERS_FAIL = "ALL_PENDING_GROUP_ORDERS_FAIL";


//complete raw orders
export const ALL_COMPLETE_RAW_ORDERS_REQUEST = "ALL_COMPLETE_RAW_ORDERS_REQUEST";
export const ALL_COMPLETE_RAW_ORDERS_SUCCESS = "ALL_COMPLETE_RAW_ORDERS_SUCCESS";
export const ALL_COMPLETE_RAW_ORDERS_FAIL = "ALL_COMPLETE_RAW_ORDERS_FAIL";


//complete group orders
export const ALL_COMPLETE_GROUP_ORDERS_REQUEST = "ALL_COMPLETE_GROUP_ORDERS_REQUEST";
export const ALL_COMPLETE_GROUP_ORDERS_SUCCESS = "ALL_COMPLETE_GROUP_ORDERS_SUCCESS";
export const ALL_COMPLETE_GROUP_ORDERS_FAIL = "ALL_COMPLETE_GROUP_ORDERS_FAIL";